// The `share` function's answers for the demo and the tests: what sharing.js does to the documents, done on the
// server in memory, so the real sync shows the outcome as it would after the real function.

import type { Fields } from "../core/records";
import type { MemoryRemote } from "./memoryRemote";
import { ShareError, type SharingActions } from "./shareService";

export function memorySharing(remote: MemoryRemote, uid: string, person: { name: string; email: string }): SharingActions {
  const read = (collection: string, id: string): Fields | undefined => remote.collection(collection).get(id);
  return {
    accept: async (invitationID, areaID) => {
      const invitation = read("invitations", invitationID);
      if (!invitation || invitation.toUID !== uid) throw new ShareError("notAllowed");
      const shareID = String(invitation.shareID);
      const share = read("shares", shareID);
      if (!share) throw new ShareError("gone");
      const members = Array.isArray(share.memberUIDs) ? share.memberUIDs.map(String) : [];
      if (!members.includes(uid)) {
        remote.update(`shares/${shareID}`, {
          memberUIDs: [...members, uid],
          members: { ...(share.members as Fields | undefined), [uid]: { name: person.name, email: person.email, role: "member" } },
        });
      }
      remote.remove(`invitations/${invitationID}`);
      if (areaID) remote.put(`users/${uid}/placements/${shareID}`, { areaID });
    },
    decline: async (invitationID) => {
      if (read("invitations", invitationID)?.toUID !== uid) throw new ShareError("notAllowed");
      remote.remove(`invitations/${invitationID}`);
    },
    leave: async (shareID) => {
      const share = read("shares", shareID);
      if (!share) throw new ShareError("gone");
      if (share.ownerUID === uid) throw new ShareError("notAllowed");
      const members = (Array.isArray(share.memberUIDs) ? share.memberUIDs.map(String) : []).filter((member) => member !== uid);
      const people = { ...(share.members as Fields | undefined) };
      delete people[uid];
      remote.update(`shares/${shareID}`, { memberUIDs: members, members: people });
      remote.remove(`users/${uid}/placements/${shareID}`);
    },
    claim: async () => {},
  };
}
